import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Cases.css';

const TELEGRAM_URL = 'https://t.me/justdisplay';

const caseImages = [
  '/images/cases/iskra%202.jpg',
  '/images/cases/iskra.jpeg',
  '/images/cases/iskra3.jpg',
  '/images/cases/nita.jpg',
  '/images/cases/secret.png',
];

const LockIcon = () => (
  <svg
    className="cases-lock-icon"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="4" y="11" width="16" height="10" rx="2" stroke="currentColor" strokeWidth="1.75" />
    <path
      d="M8 11V8a4 4 0 0 1 8 0v3"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <circle cx="12" cy="16" r="1.25" fill="currentColor" />
  </svg>
);

const Cases = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section className="cases" id="cases" ref={ref}>
      <motion.div
        className="cases-container"
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.8 }}
      >
        <motion.h2
          className="section-title cases-title"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Это уже работает
        </motion.h2>
      </motion.div>

      <motion.div
        className="cases-gallery-scroll"
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, delay: 0.35 }}
      >
        <div className="cases-gallery">
          {caseImages.map((src, index) => {
            const isSecret = src.includes('secret.png');

            return (
              <div
                key={src}
                className={`cases-gallery-item${isSecret ? ' cases-gallery-item--secret' : ''}`}
              >
                <img src={src} alt={isSecret ? 'Скрытые проекты' : `Кейс ${index + 1}`} />
                {isSecret && (
                  <div className="cases-secret-overlay">
                    <LockIcon />
                    <p className="cases-secret-text">
                      Узнайте о всех проектах на демонстрации
                    </p>
                    <a
                      href={TELEGRAM_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cases-secret-button"
                    >
                      Записаться
                    </a>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </motion.div>
    </section>
  );
};

export default Cases;
